import { NodeApi } from "react-arborist";
import "./style.scss";
import { VariationTreeNode } from ".";
import OliverText, { TextType } from "@builder/components/general/OliverText";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { selectNode } from "@builder/store/slices/BuilderSlice/builderSlice";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import classNames from "classnames";

interface RenderConditionalVariationTreeNodeProps {
    node: NodeApi<VariationTreeNode>;
    dragHandle?: React.RefCallback<HTMLDivElement>;
    rest: any;
    treeIndex: number;
    toggleCollapse: (treeIndex: number, nodeApi: NodeApi<VariationTreeNode>) => void;
}

const RenderConditionalVariationTreeNode = ({ node, dragHandle, rest, treeIndex, toggleCollapse }: RenderConditionalVariationTreeNodeProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode);

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        dispatch(selectNode(node.data.id));
    };

    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        toggleCollapse(treeIndex, node);
    };

    return (
        <div className="cv-tree-node-wrapper" data-id={node.data.id} ref={dragHandle} {...rest}>
            <div className="cv-tree-node-header">
                <div className="cv-tree-node-toggle-wrapper">
                    {node.data.hasChildren && (
                        <button className="cv-tree-toggle-button" onClick={handleToggle}>
                            <img src="/angled-arrow-down.svg" className={node.isOpen ? "rotated" : ""} />
                        </button>
                    )}
                </div>
                <div
                    className={classNames("cv-tree-node-title", {
                        selected: node.data.id === selectedNode?.id
                    })}
                    onClick={handleClick}
                >
                    <img src={node.data.icon} />
                    <OliverText type={TextType.BODY_4} text={node.data.name} translatePrefix="builderElements." />
                </div>
            </div>
        </div>
    );
};

export default RenderConditionalVariationTreeNode;
